import SolutionPage from './SolutionPage';

export default SolutionPage;
